/**
 * Formatta in una stringa l'errore che presenta un titolo e una descrizione.
 *
 * Se la descrizione è uguale al titolo, non la ripete. Se è presente un codice,
 * lo aggiunge in coda.
 */
function getTitleDescriptionError(err: any) {
  const title = err.response.data.titolo as string;
  const description = err.response.data.descrizione as string;
  const errorCode = err.response.data.codice as string;

  // Evitiamo di ripetere la descrizione se è uguale al titolo
  const descriptionString =
    description && title !== description ? `: ${description}` : '';
  const codeString = errorCode ? ` (Cod. ${errorCode})` : '';

  // console.log({ diff: title !== description, title, description });

  // Ritorniamo il titolo, la descrizione e il codice
  return `${title}${descriptionString}${codeString}`;
}

/**
 * Ottiene il messaggio di un errore avvenuto a livello di network.
 */
// TODO/MERGE Sostituire quello in auth con questo
export function getNetworkErrorMessage(
  err: any,
  defaultMessage?: string,
): string | undefined {
  if (err?.response?.data?.message) {
    return err.response.data.message;
  }

  try {
    if (err.response.data instanceof ArrayBuffer) {
      const data = JSON.parse(
        new TextDecoder('utf-8').decode(err.response.data),
      );
      if (data?.message) return data.message;
      if (data?.descrizione) return data.descrizione;
      if (data?.messaggio) return data.messaggio;
      if (data?.messaggioDiErrore) return data.messaggioDiErrore;

      return defaultMessage;
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'production') {
      console.warn(`[getNetworkErrorMessage.failToParse]`, e);
    }
    return defaultMessage;
  }

  if (err?.response?.data?.titolo) {
    return getTitleDescriptionError(err);
  }

  if (err?.response?.data?.descrizione) {
    return err.response.data.descrizione;
  }

  if (err?.response?.data?.esito?.errore?.messaggioDiErrore) {
    return err?.response?.data?.esito?.errore?.messaggioDiErrore;
  }

  if (err?.response?.data?.errore?.messaggioDiErrore) {
    return err?.response?.data?.errore?.messaggioDiErrore;
  }

  if (err?.message) return err.message;

  return err || defaultMessage;
}
